'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = undefined;
exports.createFeedStore = createFeedStore;

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = require('redux');

var _hudlVideoInterface = require('hudl-video-interface');

var _hudlBase = require('hudl-base');

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raw = _hudlBase.data.raw() || {};

var _raw$hudl = raw.hudl,
    hudlData = _raw$hudl === undefined ? {} : _raw$hudl;
var currentTeamId = hudlData.currentTeamId,
    userId = hudlData.userId;
var defaultState = exports.defaultState = {
  feedItems: {},
  userDetails: {
    teamId: currentTeamId,
    userId: userId
  }
};

function createFeedStore(model) {
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  var defaultStateCopy = JSON.parse(JSON.stringify(defaultState));
  var initialState = Object.assign({}, defaultStateCopy, model);
  var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, _hudlVideoInterface.viMiddleware))(_redux.createStore);
  var store = createStoreWithMiddleware((0, _redux.combineReducers)(_reducers2.default), initialState);
  return store;
}

var store = {
  defaultState: defaultState,
  createFeedStore: createFeedStore
};

exports.default = store;